import React from 'react';
import {
  Input, Card, Table, Button, Breadcrumb,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { PlusOutlined } from '@ant-design/icons';

import withAuth from '@common/hocs/withAuth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import MainLayout from '@common/layouts/MainLayout';

import useFirmwares from './useFirmwares';
import styles from './Firmwares.module.less';

function Firmwares() {

  const { t } = useTranslation();
  const {
    loading,
    pagination,
    columns,
    firmwares,
    arrayFilter,
    setValueFilter,
    // onChangeSearch,
    handleTableChange,
    createFirmware,
    isCreate
  } = useFirmwares();

  return (
    <MainLayout applyWidthLimit>
      <div className={styles.wrapper}>
        <Breadcrumb className={styles.date_wrapper}>
          <Breadcrumb.Item className={styles.breadcrumb}>{t('menu_items.main.firmwares')}</Breadcrumb.Item>
        </Breadcrumb>
        <div className={styles.rowHeader}>
          <Input
            placeholder={t('common.firmware_find')}
            className={styles.search}
            onChange={(e) => setValueFilter(e.target.value)}
            // onChange={onChangeSearch}
            suffix={<FontAwesomeIcon icon={faSearch} />}
            allowClear
          />

          {
            isCreate &&
            <div className={styles.button}>
              {`• ${firmwares.length} ${t('views.create_firmwares.conectedFirmwares')}`}
              <Button type="primary" onClick={createFirmware} icon={<PlusOutlined />}>
                {t('views.create_firmwares.new_firmware')}
              </Button>
            </div>
          } 
        </div>

        <Card>
          <Table
            // scroll={{ x: 1210 }}
            className={styles.table}
            loading={loading}
            columns={columns}
            dataSource={arrayFilter}
            pagination={pagination}
            onChange={handleTableChange}
            rowKey={(record) => record.id}
          />
        </Card>
      </div>
    </MainLayout>
  );

}

export default withAuth(Firmwares);
